export default __webpack_public_path__ + "701c1ee98e184b38d2baadd0257c5235.png";